"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SelectControl_1 = __importDefault(require("../SelectControl/SelectControl"));
var InputControl_1 = __importDefault(require("../InputControl/InputControl"));
var fieldNames = [
    "content_id",
    "event_type",
    "content_url",
    "parent_id",
    "parent_url",
    "content_type",
    "variant",
    "viewmode",
    "pagetype",
    "region",
    "grid_container_number",
    "grid_container_name",
    "grid_slot_number",
    "grid_box_number",
    "grid_box_type",
    "list_number",
    "screen_number",
    "breakpoint",
    "referer_domain",
    "referer_path",
    "tag",
];
var comparisonOperators = [
    "=",
    ">",
    ">=",
    "<",
    "<=",
    "!=",
    "IN",
    "NOT IN",
    "IS NULL",
    "IS NOT NULL",
];
var ConditionControl = function (_a) {
    var condition = _a.condition, onChange = _a.onChange;
    var handleFieldChange = function (field) {
        onChange(__assign(__assign({}, condition), { field: field }));
    };
    var handleOperationChange = function (operation) {
        onChange(__assign(__assign({}, condition), { compare: operation }));
    };
    var handleValueChange = function (value) {
        onChange(__assign(__assign({}, condition), { value: value }));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(SelectControl_1.default, { value: condition.field, options: fieldNames.map(function (field) { return ({ value: field, label: field }); }), onChange: handleFieldChange }), (0, jsx_runtime_1.jsx)(SelectControl_1.default, { value: condition.compare, options: comparisonOperators.map(function (op) { return ({ value: op, label: op }); }), onChange: handleOperationChange }), typeof condition.value == "string" ?
                (0, jsx_runtime_1.jsx)(InputControl_1.default, { value: condition.value, onChange: function (value) { return handleValueChange(value); } })
                :
                    null, typeof condition.value == "number" ?
                (0, jsx_runtime_1.jsx)(InputControl_1.default, { type: "number", value: "".concat(condition.value), onChange: function (value) { return handleValueChange(parseInt(value)); } })
                :
                    null] }));
};
exports.default = ConditionControl;
